import React, { useState } from "react";
import {
  Button,
  Carousel,
  CarouselControl,
  CarouselIndicators,
  CarouselItem,
  Col,
  Container,
  Row,
} from "reactstrap";
import drugImage from "../../../../assets/inventory/drug-image.svg";
import sortArrow from "../../../../assets/inventory/sort-arrows.svg";
import upArrow from "../../../../assets/inventory/up-arrow.svg";
import downArrow from "../../../../assets/inventory/down-arrow.svg";

const UpdateOnHand = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [increment, setIncrement] = useState(5);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };
  const items = [
    {
      src: drugImage,
      key: 1,
      drugName: "Yellow, Oblong, Tablet, LU G13",
    },
    {
      src: drugImage,
      key: 2,
      drugName: "Yellow, Oblong, Tablet, LU G13",
    },
    {
      src: drugImage,
      key: 3,
      drugName: "Yellow, Oblong, Tablet, LU G13",
    },
    {
      src: drugImage,
      key: 4,
      drugName: "Yellow, Oblong, Tablet, LU G13",
    },
  ];
  const slides = items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
      >
        {" "}
        <img
          src={item.src}
          style={{ display: "flex", justifyContent: "center", margin: "auto" }}
        />
        <div className="physical-description" style={{ height: "20px" }}></div>
        <div className="physical-description">Physical Descripitons</div>
        <div className="medicine-name">{item.drugName}</div>
      </CarouselItem>
    );
  });
  return (
    <>
      <div className="invOrderDetails">
        <div>
          <Row className="mb-3 mt-2">
            <Col md="4">
              <div className="invHeadDetails">Product Name</div>
              <div className="inv-details">Lisinopril 10mg Tablet</div>
            </Col>
            <Col md="4">
              <div className="invHeadDetails">NDC</div>
              <div className="inv-details">34981-3198-99</div>
            </Col>
            <Col md="4">
              <div className="invHeadDetails">Manufacturer</div>
              <div className="inv-details">McKessson</div>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="4">
              <div className="invHeadDetails">Package Size</div>
              <div className="inv-details">100 EA</div>
            </Col>
            <Col md="4">
              <div className="invHeadDetails">Current On-Hand Qty</div>
              <div className="inv-details">283</div>
            </Col>
            <Col md="4">
              <div className="invHeadDetails">Package Description</div>
              <div className="inv-details">Bottle</div>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md="4">
              <div className="invHeadDetails">Unit Description</div>
              <div className="inv-details">Tablet</div>
            </Col>
            <Col md="4">
              <div className="invHeadDetails">Par Level </div>
              <div className="inv-details">83</div>
            </Col>
            <Col md="4">
              <div className="invHeadDetails">Last Cycle Count</div>
              <div className="inv-details">11/04/2025</div>
            </Col>
          </Row>
        </div>
        
        <div className="tabletImg">Drug Image</div>
<div style={{height:"400px"}}>
        <Carousel
          className="pt-0"
          slide={false}
          activeIndex={activeIndex}
          next={next}
          previous={previous}
        >
          <CarouselIndicators
            items={items}
            activeIndex={activeIndex}
            onClickHandler={goToIndex}
            style={{ position: "relative", top: "227px" }}
          />
          {slides}

          <CarouselControl
            direction="prev"
            directionText="Previous"
            onClickHandler={previous}
          ></CarouselControl>
          <CarouselControl
            direction="next"
            directionText="Next"
            onClickHandler={next}
          />
        </Carousel>
        </div>
        {/* <div className="quality-required d-flex justify-content-around">
          <div className="qty-head-text">
            Full Packages <img src={sortArrow} />
          </div>
          <div className="qty-head-text">
            {" "}
            Unit Description <img src={sortArrow} />
          </div>
        </div> */}
        <Container fluid className="mb-2">
        <Row className="quality-required-cycle ">
          <Col lg={6} md={6} sm={6} className="cycle-head">
            Full Packages <img src={sortArrow} style={{ marginLeft: "8px" }} />
          </Col>
          <Col lg={6} md={6} sm={6} className="cycle-head">
            Unit Description{" "}
            <img src={sortArrow} style={{ marginLeft: "8px" }} />
          </Col>
        </Row>
        <Row>
        <div className="d-flex" style={{ gap: "12px", marginTop: "8px" }}>
          <div className="qty-count ">
            <div>{increment}</div>
            <div className="d-flex flex-column cursor-pointer">
              <img src={upArrow} onClick={() => setIncrement(increment + 1)} />
              <img
                src={downArrow}
                onClick={() => setIncrement(increment - 1)}
              />
            </div>
          </div>
          <div className="qty-count ">
            <div>{increment}</div>
            <div className="d-flex flex-column cursor-pointer">
              <img src={upArrow} onClick={() => setIncrement(increment + 1)} />
              <img
                src={downArrow}
                onClick={() => setIncrement(increment - 1)}
              />
            </div>
          </div>
          <div className="d-flex  justify-content-end">
            <Button color="primary">Add</Button>
          </div>
        </div>
      </Row>
      {/* <div className="sep"></div> */}
      
      </Container>
      <div className="update-on-footer"></div>
      </div>

    </>
  );
};

export default UpdateOnHand;
